import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  message,
  Input,
  Button,
  Table,
  Modal,
  Spin,
  Tag,
  Typography,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import InspectionForm from "./inspectionForm";
import axios from "axios";

const { Search } = Input;
const { Title } = Typography;

const Inspections = () => {
  const [inspectionsData, setInspectionsData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchInspections();
  }, [submitted]);

  const fetchInspections = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/inspections");
      setInspectionsData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      message.error("Unable to load inspections");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    const filtered = inspectionsData.filter((inspection) =>
      Object.keys(inspection).some((key) =>
        String(inspection[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const highlightText = (text, searchText) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.toString().split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#fffb8f",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleAddInspection = () => {
    setFormData(null);
    setModalVisible(true);
  };

  const handleEditInspection = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleViewDetails = (id) => {
    history.push(`/inspectionDetails/${id}`);
  };

  const columns = [
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
      render: (_, record) =>
        highlightText(
          `${record.vehicle.plateNumber} (${record.vehicle.model})`,
          searchQuery
        ),
    },
    {
      title: "Inspection Date",
      dataIndex: "inspectionDate",
      key: "inspectionDate",
      render: (date) =>
        highlightText(new Date(date).toLocaleDateString(), searchQuery),
    },
    {
      title: "Fuel Status",
      dataIndex: "fuelStatus",
      key: "fuelStatus",
      render: (fuelStatus) => (
        <span>
          <Tag
            color={fuelStatus === "Full" ? "green" : "red"}
            icon={fuelStatus === "Full" ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
          >
            {highlightText(fuelStatus, searchQuery)}
          </Tag>
        </span>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text) => highlightText(text || "N/A", searchQuery),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>
          {highlightText(status, searchQuery)}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditInspection(record)}
            style={{ marginRight: 8, color: "#0c8c49" }}
          >
            Edit
          </Button>
          <Button
            type="link"
            icon={<InfoCircleOutlined />}
            onClick={() => handleViewDetails(record.id)}
            style={{ color: "#0c8c49" }}
          >
            Details
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Vehicle Inspections
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Search
              placeholder="Search Inspections"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddInspection}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Inspection
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 5 }}
            rowKey="id"
            bordered
          />
        )}
      </Card>
      <Modal
        title={formData ? "Edit Inspection" : "Add Inspection"}
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        centered
        width="50%"
        style={{ borderRadius: "10px" }}
        bodyStyle={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <InspectionForm
          inspectionData={formData}
          setInspectionData={setFormData}
          closeModal={() => setModalVisible(false)}
          setSubmitted={setSubmitted}
        />
      </Modal>
    </div>
  );
};

export default Inspections;
